import { render, staticRenderFns } from "./GraphExplorerDrawerTransaction.vue?vue&type=template&id=54a71fab&scoped=true&"
import script from "./GraphExplorerDrawerTransaction.vue?vue&type=script&setup=true&lang=js&"
export * from "./GraphExplorerDrawerTransaction.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a71fab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
